// extracted by css-extract-rspack-plugin
export default {"wizard":"a14k58_tQ1wiygFB"};